import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import BackgroundWidget from '../../../widgets/projectProposal/backgroundAndImportant/BackgroundWidget'
import GarbageBGWidget from '../../../widgets/projectProposal/backgroundAndImportant/backgroundOfGarbage/GarbageBGWidget'
import BackgroundExerciseActivityWidget from '../../../widgets/projectProposal/backgroundAndImportant/exerciseActivity/BackgroundExerciseActivityWidget'
import OrganicVegetablesBGWidget from '../../../widgets/projectProposal/backgroundAndImportant/organicVegetablesWidgets/OrganicVegetablesBGWidget'
import PromoteEatingFruitsAndVegetablesWidget from '../../../widgets/projectProposal/backgroundAndImportant/promoteEatingFruitsAndVegetables/PromoteEatingFruitsAndVegetablesWidget'
import ReduceAlcoholBGWidget from '../../../widgets/projectProposal/backgroundAndImportant/reduceAlcoholWidgets/ReduceAlcoholBGWidget'
import BackgroundReduceSmokingWidget from '../../../widgets/projectProposal/backgroundAndImportant/reduceSmokingWidgets/BackgroundReduceSmokingWidget'
import BackgroundOfElderlyWidget from '../../../widgets/projectProposal/backgroundAndImportant/elderlyWidget/BackgroundOfElderlyWidget'
import BackgroundOfRiskPointsWidget from '../../../widgets/projectProposal/backgroundAndImportant/riskPointsWidget/BackgroundOfRiskPointsWidget'
import RightSidebarPDF from '../../../components/RightSidebarPDF'
import '../styles.less'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { getBackground } from '../../../redux/actions/background'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'
import BackgroundForm9Widget from '../../../widgets/projectProposal/backgroundAndImportant/form9/BackgroundForm9Widget'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'

export default function BackgroundAndImportant() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [showEditAll, setShowEditAll] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  
  // 🚩 เพิ่ม State ควบคุมสถานะการเปิด/ปิดโหมดเปรียบเทียบ
  const [isViewPrevious, setIsViewPrevious] = useState(false)

  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.objectiveGoal}`,
    pathNameForward: `${pathname.proposal.targetSetting}`,
  }

  useEffect(() => {
    if (projectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getBackground(projectId)
      // const _schema = mock_schema
      setSchema(_schema)
      let key = Object.keys(_schema.forms)
      setIsEditWidget({
        [key]: _schema.forms?.[key]?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.[key]?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  // 🚩 ปรับ Logic การดึงข้อมูลให้เป็นสวิตช์เปิด-ปิด และใช้ข้อมูลเก่าหากเคยดึงมาแล้ว
  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      // ปิดโหมดเปรียบเทียบ
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      // เปิดโหมดเปรียบเทียบ โดยใช้ข้อมูลที่เคยโหลดมาแล้ว
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }

      const _schema = await getBackground(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // 🚩 สกัดข้อมูลปัจจุบันทั้งหมดออกมาเก็บไว้ เพื่อให้สลับการครอบด้วย Panel ได้ง่าย
  const renderCurrentVersion = (
    <div className="top">
      {schema?.forms?.form0 && (
        <>
          <BackgroundWidget
            showCommandButton={!schema.forms.form0.disabled}
            schema={schema.forms.form0}
            isEdit={isEditWidget.form0}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form0', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.form1 && (
        <>
          <ReduceAlcoholBGWidget
            showCommandButton={!schema.forms.form1.disabled}
            schema={schema.forms.form1}
            isEdit={isEditWidget.form1}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form1', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.form2 && (
        <>
          <GarbageBGWidget
            showCommandButton={!schema.forms.form2.disabled}
            schema={schema.forms.form2}
            isEdit={isEditWidget.form2}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form2', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.form3 && (
        <>
          <OrganicVegetablesBGWidget
            showCommandButton={!schema.forms.form3.disabled}
            schema={schema.forms.form3}
            isEdit={isEditWidget.form3}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form3', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.form4 && (
        <>
          <PromoteEatingFruitsAndVegetablesWidget
            showCommandButton={!schema.forms.form4.disabled}
            schema={schema.forms.form4}
            isEdit={isEditWidget.form4}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form4', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.form5 && (
        <>
          <BackgroundOfElderlyWidget
            showCommandButton={!schema.forms.form5.disabled}
            schema={schema.forms.form5}
            isEdit={isEditWidget.form5}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form5', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.form6 && (
        <>
          <BackgroundOfRiskPointsWidget
            showCommandButton={!schema.forms.form6.disabled}
            schema={schema.forms.form6}
            isEdit={isEditWidget.form6}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form6', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.form7 && (
        <>
          <BackgroundReduceSmokingWidget
            showCommandButton={!schema.forms.form7.disabled}
            schema={schema.forms.form7}
            isEdit={isEditWidget.form7}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form7', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.form8 && (
        <>
          <BackgroundExerciseActivityWidget
            showCommandButton={!schema.forms.form8.disabled}
            schema={schema.forms.form8}
            isEdit={isEditWidget.form8}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form8', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.form9 && (
        <>
          <BackgroundForm9Widget
            showCommandButton={!schema.forms.form9.disabled}
            schema={schema.forms.form9}
            isEdit={isEditWidget.form9}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('form9', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}
    </div>
  )

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />
        
        {/* 🚩 ส่ง State ให้ปุ่ม */}
        <ViewPreviousVersionButon 
          handleGetSchemaPrevious={handleGetSchemaPrevious} 
          isViewPrevious={isViewPrevious}
          masterSubjectId={'1-1013,5-5007'}
        />

        {/* 🚩 ย้าย BtnEditAll มาไว้ข้างนอก wrapper เพื่อให้แสดงผลได้ถูกต้องทั้ง 2 โหมด */}
        {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            routing={buttonRoute}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            editWidget={isEditWidget}
            forms={schema?.forms}
          />
        )}

        <div className="wrapper">
          {/* ==============================================
              ส่วนที่ 1: แสดงข้อมูลปัจจุบัน (สลับมี/ไม่มี Panel)
              ============================================== */}
          <div style={!isViewPrevious ? { width: '100%' } : {}}>
            {isViewPrevious ? (
              <Panel 
                //classPrefix="view-version-panel" 
                collapsible 
                defaultExpanded 
                shaded 
                bordered 
                header={'version ปัจจุบัน'}
                style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
              >
                {renderCurrentVersion}
              </Panel>
            ) : (
              renderCurrentVersion
            )}
          </div>

          {/* ==============================================
              ส่วนที่ 2: แสดงข้อมูลก่อนหน้า (แสดงเฉพาะตอนที่มีการกดปุ่ม)
              ============================================== */}
          {isViewPrevious && schemaPrevious && (
            <>
              <div className="line" />
              <div className="bottom">
                <Panel 
                  collapsible 
                  defaultExpanded 
                  shaded
                  bordered 
                  header={'version ก่อนหน้า'}
                  style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed'  }}
                >
                  {schemaPrevious?.forms?.form0 && (
                    <>
                      <BackgroundWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form0}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.form1 && (
                    <>
                      <ReduceAlcoholBGWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form1}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.form2 && (
                    <>
                      <GarbageBGWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form2}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.form3 && (
                    <>
                      <OrganicVegetablesBGWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form3}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.form4 && (
                    <>
                      <PromoteEatingFruitsAndVegetablesWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form4}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.form5 && (
                    <>
                      <BackgroundOfElderlyWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form5}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.form6 && (
                    <>
                      <BackgroundOfRiskPointsWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form6}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.form7 && (
                    <>
                      <BackgroundReduceSmokingWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form7}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.form8 && (
                    <>
                      <BackgroundExerciseActivityWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form8}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.form9 && (
                    <>
                      <BackgroundForm9Widget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.form9}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}
                </Panel>
              </div>
            </>
          )}
        </div>

        {/* {!onClickBackground && <RightSidebarPDF data={editorData} />} */}
      </SidebarProposal>
    </>
  )
}